import {
    Box,
    Container,
    Flex,
    Grid,
    GridItem,
    Highlight,
    Image,
    Stack,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { useState } from "react";

import ContactModal from "@/components/general/contactModal";

const SitesCards = () => {
    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });
    const [isOpen, setIsOpen] = useState(false);

    const onClose = () => setIsOpen(false);
    const onOpen = () => setIsOpen(true);

    const sitesButtonHandler = (link) => {
        window.open(link, "_blank");
    };

    const developerQuestionText = "¿Eres \n desarrollador?";

    return (
        <Box w="full" mx="auto" bg="white">
            <Container maxW="7xl" mx="auto" px={{ base: 4, xl: 0 }}>
                <Box mt={2} mb={8}>
                    <Text as="h2" fontSize={{ base: "md", md: "lg", lg: "2xl" }} textAlign="center">
                        <Highlight
                            query="Guía, el mejor lugar para ti.."
                            styles={{ fontWeight: "700" }}
                        >
                            Guía, el mejor lugar para ti..
                        </Highlight>
                    </Text>
                </Box>
                <Grid
                    templateColumns="repeat(4, 1fr)"
                    role="grid"
                    aria-label="Sección de servicios inmobiliarios"
                >
                    {/* Card 1 - Soy Inmobiliaria */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 2 : 4}
                        role="section"
                        aria-label="Servicio para inmobiliarias"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "0px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={() => sitesButtonHandler("https://grupoguia.mx/procesos")}
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v5/building-close_up.png)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v5/building-close_up.png"
                                    alt="Servicios para inmobiliarias - Grupo Guía"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Text
                                        as="h3"
                                        color="white"
                                        fontSize={{ base: "md", md: "md", lg: "lg", xl: "xl" }}
                                        fontWeight={700}
                                    >
                                        Soy Inmobiliaria
                                    </Text>
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Card 2 - GuiaConnect */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Soluciones de renta"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "10px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={() =>
                                    sitesButtonHandler("https://grupoguia.mx/landing-guiarent")
                                }
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/guiaconnect.webp)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/guiaconnect.webp"
                                    alt="GuiaConnect - Soluciones de renta"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/card/guiarent.svg"
                                        alt="Logo GuiaConnect"
                                        width={{ base: "100px", lg: "120px", xl: "140px" }}
                                    />
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Repite el mismo patrón para las demás cards */}
                    {/* Card 3 - GuiaBroker */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Servicios para brokers"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "0px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={() =>
                                    sitesButtonHandler("https://grupoguia.mx/guiabroker")
                                }
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/brokers.webp)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/brokers.webp"
                                    alt="GuiaBroker - Servicios para brokers"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/card/guiabrokers.svg"
                                        alt="Logo GuiaBroker"
                                        width={{ base: "130px", lg: "150px", xl: "195px" }}
                                        height="auto"
                                    />
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Card 4 - GuiaLink */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Servicio para precalificaciones"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "10px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={() => sitesButtonHandler("https://grupoguia.mx/guialink/")}
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v5/couple-buying.png)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v5/couple-buying.png"
                                    alt="GuiaLink - Encuentra tu propiedad ideal"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/card/logo_guialink.svg"
                                        alt="Logo GuiaLink"
                                        width={{ base: "95px", lg: "120px", xl: "140px" }}
                                        height="auto"
                                    />
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Card 5 - Publica tu propiedad */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Publica tu propiedad en Grupo Guía"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "0px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={onOpen}
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/public.webp)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/public.webp"
                                    alt="Publica tu propiedad en Grupo Guía"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Text
                                        as="h3"
                                        color="white"
                                        fontSize={{ base: "md", md: "md", lg: "lg", xl: "xl" }}
                                        textAlign="center"
                                        width="100%"
                                        fontWeight={700}
                                    >
                                        Publica hoy <br />
                                        tu propiedad
                                    </Text>
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Card 6 - Desarrolladores */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Soluciones para desarrolladores inmobiliarios"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "10px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={onOpen}
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/desarrollador.webp)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v4/cards/v2/desarrollador.webp"
                                    alt="Soluciones para desarrolladores inmobiliarios"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Text
                                        as="h3"
                                        color="white"
                                        fontSize={{ base: "md", md: "md", lg: "lg", xl: "xl" }}
                                        textAlign="center"
                                        width="100%"
                                        whiteSpace="pre-line" // Permite saltos de línea con \n
                                        lineClamp={2}
                                        fontWeight={700}
                                    >
                                        {developerQuestionText}
                                    </Text>
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>

                    {/* Card 7 - Encuentra asesor */}
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 2}
                        role="section"
                        aria-label="Asesores inmobiliarios certificados"
                    >
                        <Stack mr={isGreaterThanMd ? "30px" : "0px"} mb="20px">
                            <Box
                                position="relative"
                                height={{ base: "173px", lg: "210px", xl: "244px" }}
                                borderRadius="xl"
                                overflow="hidden"
                                cursor="pointer"
                                onClick={onOpen}
                                _hover={{ opacity: 0.98, transform: "scale(1.01)" }}
                            >
                                <Box
                                    position="absolute"
                                    top={0}
                                    left={0}
                                    right={0}
                                    bottom={0}
                                    backgroundImage="url(https://media.grupoguia.mx/assets/home-page/Homepage-v5/panoramic-buildings.png)"
                                    bgPosition="center"
                                    bgRepeat="no-repeat"
                                    bgSize="cover"
                                />
                                <img
                                    src="https://media.grupoguia.mx/assets/home-page/Homepage-v5/panoramic-buildings.png"
                                    alt="Asesores inmobiliarios certificados"
                                    style={{
                                        position: "absolute",
                                        width: "1px",
                                        height: "1px",
                                        opacity: 0,
                                    }}
                                />
                                <Flex
                                    position="relative"
                                    height="100%"
                                    alignItems="center"
                                    justifyContent="center"
                                    zIndex={1}
                                >
                                    <Text
                                        as="h3"
                                        color="white"
                                        fontSize={{ base: "md", md: "md", lg: "lg", xl: "xl" }}
                                        textAlign="center"
                                        width="100%"
                                        fontWeight={700}
                                    >
                                        Encuentra un <br />
                                        asesor
                                    </Text>
                                </Flex>
                            </Box>
                        </Stack>
                    </GridItem>
                </Grid>
            </Container>
            <ContactModal isOpen={isOpen} onClose={onClose} />
        </Box>
    );
};

export default SitesCards;
